const Header = () => import('@/components/service/Header/index');
const Footer = () => import('@/components/service/Footer/index');
const serviceTask = () => import('@/views/service/serviceTask.vue');
const serviceHistory = () => import('@/views/service/serviceHistory.vue');
const serviceMy = () => import('@/views/technician/techMy.vue');
// 嵌套西藏在线客服
const serviceOnline = () => import('@/views/online/service.vue');

export default [
    {
        path: '/serviceTask',
        name: 'serviceTask',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '当前任务',
        },
        components: {
            default: serviceTask,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/serviceHistory',
        name: 'serviceHistory',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '历史任务',
        },
        components: {
            default: serviceHistory,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/serviceMy',
        name: 'serviceMy',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '我的',
        },
        components: {
            default: serviceMy,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/serviceOnline',
        name: 'serviceOnline',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '西藏在线客服',
        },
        components: {
            default: serviceOnline,
        }
    },
];




